import { render, staticRenderFns } from "./BookSelectBuy.vue?vue&type=template&id=1efd5253&scoped=true&"
import script from "./BookSelectBuy.vue?vue&type=script&lang=js&"
export * from "./BookSelectBuy.vue?vue&type=script&lang=js&"
import style0 from "./BookSelectBuy.vue?vue&type=style&index=0&id=1efd5253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd5253",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efd5253')) {
      api.createRecord('1efd5253', component.options)
    } else {
      api.reload('1efd5253', component.options)
    }
    module.hot.accept("./BookSelectBuy.vue?vue&type=template&id=1efd5253&scoped=true&", function () {
      api.rerender('1efd5253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2024/BookSelectBuy.vue"
export default component.exports